import { WwWorkType } from '@/configs/enums/commons';

export default [
  {
    path: '/',
    name: 'M020001',
    component: () => import('@/views/admin/main/home/Index.vue'),
    meta: { layout: 'admin', title: '首页' },
  },
  {
    path: '/platform/login',
    name: 'platform-login',
    component: () => import('@/views/admin/login/common/LoginMain.vue'),
    meta: { layout: 'front', isLogin: true },
  },
  {
    path: '/deploy/login',
    name: 'deploy-login',
    component: () => import('@/views/admin/login/common/LoginMain.vue'),
    meta: { layout: 'front', isLogin: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/admin/login/common/LoginMain.vue'),
    meta: { layout: 'front', isLogin: true },
  },
  {
    path: '/personal-center',
    name: 'M010002',
    component: () => import('@/views/admin/personal-center/PersonalCenter.vue'),
    meta: { layout: 'admin', title: '个人中心' },
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/empty/help-view/ChangeBrowserHelp.vue'),
    meta: { layout: 'empty' },
  },
  // 帮助文档预览
  {
    path: '/front/helper-doc/helper-doc/index',
    name: 'front-helper-doc-helper-doc-indx',
    component: () =>
      import('@/views/empty/helper-doc/helper-doc/HelperDocIndex.vue'),
    meta: { layout: 'empty', notCheckAuth: true },
  },
  {
    path: '/front/helper-doc/helper-doc/mobile',
    name: 'front-helper-doc-helper-doc-mobile',
    component: () =>
      import('@/views/empty/helper-doc/helper-doc/HelperDocMobile.vue'),
    meta: { layout: 'empty', notCheckAuth: true },
  },
  {
    path: '/404',
    name: 'error-404',
    component: () => import('@/views/empty/error/Error404.vue'),
    meta: { layout: 'empty', noTab: true },
  },
  {
    path: '/500',
    name: 'error-500',
    component: () => import('@/views/empty/error/Error500.vue'),
    meta: { layout: 'empty', noTab: true },
  },
  {
    path: '/:catchAll(.*)',
    name: 'error-all',
    component: () => import('@/views/empty/error/Error404.vue'),
    meta: { layout: 'empty', noTab: true },
  },
  {
    path: '/wx-login-redirect',
    name: 'wx-login',
    component: () => import('@/views/admin/login/common/WxLoginRedirect.vue'),
    meta: { layout: 'front', isLogin: true },
    hidden: true,
  },
  {
    path: '/wx-bind-redirect',
    name: 'wx-bind',
    component: () =>
      import('@/views/admin/personal-center/components/WxBindRedirect.vue'),
    meta: { layout: 'front', isLogin: true },
    hidden: true,
  },
  {
    path: '/flow/redirect',
    name: 'flow-redirect',
    component: () => import('@/views/front/flow/message/Redirect.vue'),
    meta: { layout: 'front', needSetToken: true },
    hidden: true,
  },
  {
    path: '/flow/redirect-external',
    name: 'flow-redirect-external',
    component: () => import('@/views/front/flow/message/Redirect.vue'),
    meta: {
      layout: 'front',
      redirectType: WwWorkType.外部消息, // 跳转类型（用于当在企业微信环境下直接访问本页面时，路由自动判断处理成对应的跳转类型）
    },
    hidden: true,
  },
  {
    path: '/login-oauth2',
    name: 'login-oauth2-redirect',
    component: () => import('@/views/admin/login/common/LoginOauth2.vue'),
    meta: { layout: 'front', isLogin: true, notNeedProgress: true },
    hidden: true,
  },
];
